import { DEFAULT_RICOS_COMPONENT_DATA } from "./defaults";
import { POLL_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers-loadable";
const pluginPoll = (config) => {
  return {
    config: { ...DEFAULT_RICOS_COMPONENT_DATA.containerData, ...config },
    type: POLL_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginPoll
};
//# sourceMappingURL=viewer-loadable.js.map
